// extracted by mini-css-extract-plugin
module.exports = {"link":"footer-nav-item_link__DXdIP"};